'use client';

export default function PostCardSkeleton() {
  return (
    <div className="mb-4 bg-white rounded-lg shadow animate-pulse">
      {/* Header */}
      <div className="p-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            {/* Platform icon placeholder */}
            <div className="w-4 h-4 bg-gray-200 rounded" />
            {/* Username placeholder */}
            <div className="h-4 w-32 bg-gray-200 rounded" />
          </div>
        </div>
        {/* Caption placeholder */}
        <div className="space-y-2 mt-2">
          <div className="h-4 w-3/4 bg-gray-200 rounded" />
          <div className="h-4 w-1/2 bg-gray-200 rounded" />
        </div>
        {/* Date placeholder */}
        <div className="h-3 w-24 bg-gray-200 rounded mt-2" />
      </div>

      {/* Media placeholder */}
      <div className="px-4 pb-4">
        <div className="w-20 h-20 bg-gray-200 rounded" />
      </div>

      {/* Comments section */}
      <div className="p-4 space-y-4">
        {/* Generate 2 comment skeletons */}
        {[1, 2].map((i) => (
          <div key={i} className="pb-4 border-b last:border-b-0">
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center gap-2">
                {/* Avatar placeholder */}
                <div className="w-6 h-6 bg-gray-200 rounded-full" />
                <div>
                  {/* Username placeholder */}
                  <div className="h-4 w-24 bg-gray-200 rounded" />
                  {/* Date placeholder */}
                  <div className="h-3 w-20 bg-gray-200 rounded mt-1" />
                </div>
              </div>
              {/* Action buttons placeholder */}
              <div className="flex gap-2">
                <div className="w-8 h-8 bg-gray-200 rounded" />
                <div className="w-8 h-8 bg-gray-200 rounded" />
              </div>
            </div>
            {/* Comment text placeholder */}
            <div className="space-y-2">
              <div className="h-4 w-full bg-gray-200 rounded" />
              <div className="h-4 w-3/4 bg-gray-200 rounded" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
